import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import notify from 'devextreme/ui/notify';
import { BehaviorSubject, filter, Observable } from 'rxjs';
import { CategorieArticoli } from 'src/app/models/categorieArticoli';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CategorieArticoliService {
  private http = inject(HttpClient);

  catArticoliUrl = environment.ildatoArticoliDpi + 'api/categoriearticoli';

  private _listCategorie = new BehaviorSubject<CategorieArticoli[] | undefined>(undefined);

  listTemp(forceRefresh: boolean = false): Observable<CategorieArticoli[]> {
    if (
      this._listCategorie.value == undefined ||
      forceRefresh
    ) {
      this.http.get<CategorieArticoli[]>(this.catArticoliUrl).subscribe({
        next: (res) => {
          this._listCategorie.next(res);
        },
        error: (err) => {
          if (err?.error?.title) {
            notify(err.error.title, 'error');
          } else {
            notify('Errore recupero lista categorie articoli', 'error');
          }
        },
      });
    }
    return this._listCategorie.asObservable().pipe(filter((r) => r != null));
  }

  cleanTemp(){
    this._listCategorie.next(undefined);
  }
}
